import { useRuntimeConfig } from "#imports";
const moduleName = "nuxt-multi-tracker";
export const useInfo = (...messages) => {
  const { debug } = useRuntimeConfig().public.multiTracker;
  if (debug)
    console.info.apply(console, [`[${moduleName}]`, ...messages]);
};
export const useGroup = (...messages) => {
  const { debug } = useRuntimeConfig().public.multiTracker;
  if (debug)
    console.group(`[${moduleName}]`, ...messages);
};
export const useGroupEnd = () => {
  const { debug } = useRuntimeConfig().public.multiTracker;
  if (debug)
    console.groupEnd();
};
export const useWarn = (...messages) => {
  console.warn(`[${moduleName}]`, ...messages);
};
export const useLogError = (...messages) => {
  console.error(`[${moduleName}]`, ...messages);
};
export const useDebug = (...messages) => {
  console.debug(`[${moduleName}]`, ...messages);
};
